import script from "./DataIngestionHistoryMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./DataIngestionHistoryMenu.vue?vue&type=script&setup=true&lang=ts"

import "./DataIngestionHistoryMenu.vue?vue&type=style&index=0&id=07c19fd6&lang=scss"

const __exports__ = script;

export default __exports__